import React, { useMemo } from 'react';
import TableBodyLoading from './TableBodyLoading';
import TableBodyEmpty from './TableBodyEmpty';
import TableBodyRows from './TableBodyRows';
import TableBodyRowsGroupBy from './TableBodyRowsGroupBy';

const TableBody = ({
  id,
  rows,
  page,
  rowsPerPage,
  columns,
  colSpan,
  loading,
  labelNoRows,
  groupBy,
  groupByRender,
  orderGroupBy,
  showSetting
}) => {
  const newRows = useMemo(() => {
    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [rows, page, rowsPerPage]);

  if (loading) {
    return <TableBodyLoading id={id} rowsPerPage={rowsPerPage} columns={columns} />;
  }

  if (rows.length === 0) {
    return <TableBodyEmpty id={id} colSpan={colSpan} labelNoRows={labelNoRows} />;
  }

  if (groupBy) {
    return (
      <TableBodyRowsGroupBy
        id={id}
        columns={columns}
        rows={newRows}
        groupBy={groupBy}
        showSetting={showSetting}
        groupByRender={groupByRender}
        orderGroupBy={orderGroupBy}
      />
    );
  }

  return <TableBodyRows id={id} columns={columns} rows={rows} />;
};

export default TableBody;
